import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Modal, ModalBody, Label } from "reactstrap"
// import "./datatables.scss";
import '../Icons/IconFontawesome';
import { AvField, AvForm, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import DeleteModal from './DeleteModal';
import DataTable from 'react-data-table-component';
// import './Card.scss';

const Table = (props) => {
  const { user, role, currentUser, path, setLoading } = props;
  const [departColumns, setDepartColumns] = useState([]);
  const [columns, setColumns] = useState([]);
  const [qualiColumns, setQualiColumns] = useState([]);
  const [departData, setDepartData] = useState([]);
  const [data, setData] = useState([]);
  const [qualiData, setQualiData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentModalData, setCurrentModalData] = useState(null);
  const [isDepartForm, setIsDepartForm] = useState(false);
  const [isCourseForm, setIsCourseForm] = useState(false);
  const [isQualiForm, setIsQualiForm] = useState(false);

  useEffect(() => {
    if (user) {
      getMetas();
    }
  }, [user]);

  const getMetas = () => {
    get("/meta/list", { token: user?.token })
      .then(json => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data?.courses);
          setQualiData(json?.data?.qualis);
          setDepartData(json?.data?.departs)
        }
      })
      .catch(error => {
        console.log('error while getting project list', error);
      })
  }

  useEffect(() => {
    setColumns([
      {
        name: 'Title',
        cell: (row) => <>
          <span title={row.title}>{row.title}</span>
        </>
      },
      {
        name: 'Is NAPS',
        selector: row => row.isNAPS ? 'Yes' : 'No',
      },
      // {
      //   name: 'Sector',
      //   selector: row => row.sector[0]?.title,
      // },
      // {
      //   name: 'Duration',
      //   selector: row => row.duration,
      // },
      // {
      //   name: 'Description',
      //   cell: (row) => <>
      //     <span title={row?.desc}>{row.desc.length>55 ? row.desc.slice(0, 55)+"..." : row.desc}</span>
      //   </>,
      // },
      {
        name: 'Created At',
        selector: row => row.createdAt,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row, 'course')}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateEdit(row, 'course')}
            title={"Edit"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleDelete(row, 'course')}
            title={"Delete"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  useEffect(() => {
    setQualiColumns([
      {
        name: 'Title',
        selector: row => row.title,
      },
      {
        name: 'Created At',
        selector: row => row.createdAt,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row, 'quali')}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateEdit(row, 'quali')}
            title={"Edit"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleDelete(row, 'quali')}
            title={"Delete"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [qualiData]);

  useEffect(() => {
    setDepartColumns([
      {
        name: 'Title',
        cell: (row) => <>
          <span title={row.title}>{row.title}</span>
        </>
      },
      {
        name: 'Created At',
        selector: row => row.createdAt,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row, 'depart')}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateEdit(row, 'depart')}
            title={"Edit"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleDelete(row, 'depart')}
            title={"Delete"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [departData]);

  useEffect(()=>{
    if(!isCourseForm && !isDepartForm && !isQualiForm)
      setCurrentModalData(null);
  }, [isCourseForm, isDepartForm, isQualiForm]);

  const handleUpdateEdit = (proj, metaType) => {
    console.log('updating proj', proj);
    setCurrentModalData(proj);
    if (metaType == 'course')
      setIsCourseForm(true);
    else if (metaType == 'quali')
      setIsQualiForm(true);
    else
      setIsDepartForm(true);
  }

  const handleDelete = (proj, metaType) => {
    console.log('updating proj', proj);
    setCurrentModalData({ ...proj, metaType, actionType: 'Delete' });
    setDeleteModal(true);
  }

  const handleUpdateStatus = (item, metaType) => {
    console.log('updating proj', item);
    setCurrentModalData({ ...item, metaType, actionType: 'Status' });
    setDeleteModal(true);
  }

  const onDelete = () => {
    console.log('deleted', currentModalData);
    let body = {
      courseId: currentModalData?._id,
      qualiId: currentModalData?._id,
      metaType: currentModalData?.metaType,
      token: user?.token
    }
    post("/meta/delete", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          getMetas();
          setDeleteModal(false);
          setCurrentModalData(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const onStatus = () => {
    console.log('deleted', currentModalData);
    let body = {
      courseId: currentModalData?._id,
      qualiId: currentModalData?._id,
      departId: currentModalData?._id,
      metaType: currentModalData?.metaType,
      isActive: !currentModalData?.isActive,
      token: user?.token
    }
    put("/meta/update", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          getMetas();
          setDeleteModal(false);
          setCurrentModalData(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const handleValidSubmit = async (e, values, type) => {
    console.log('values', values);
    setLoading(true);
    let body = null;
    let url = "/meta/add";
    let json = null;
    if (type == 'course') {
      let isNAPS = false;
      if (values?.isNAPS == 'yes')
        isNAPS = true;
      body = {
        ...values,
        addedBy: user?._id,
        isNAPS,
        metaType: type,
        token: user?.token
      };
      if (currentModalData) {
        body = { ...body, courseId: currentModalData?._id };
        url = "/meta/update";
        json = await put(url, body);
      } else {
        json = await post(url, body);
      }
    } else if (type == 'quali') {
      body = {
        ...values,
        addedBy: user?._id,
        metaType: type,
        token: user?.token
      };
      if (currentModalData) {
        body = { ...body, qualiId: currentModalData?._id };
        url = "/meta/update";
        json = await put(url, body).catch(error => { setLoading(false); toast.error('Something Went Wrong!') });
      } else {
        json = await post(url, body).catch(error => { setLoading(false); toast.error('Something Went Wrong!') });
      }
    } else if (type == 'depart') {
      body = {
        ...values,
        addedBy: user?._id,
        metaType: type,
        token: user?.token
      };
      if (currentModalData) {
        body = { ...body, departId: currentModalData?._id };
        url = "/meta/update";
        json = await put(url, body).catch(error => { setLoading(false); toast.error('Something Went Wrong!') });
      } else {
        json = await post(url, body).catch(error => { setLoading(false); toast.error('Something Went Wrong!') });
      }
    }
    console.log('response from adding meta', json);
    setLoading(false);
    if (json.statusCode == 200) {
      console.log('meta added');
      toast.success(json?.message);
      setCurrentModalData(null);
      setIsCourseForm(false);
      setIsQualiForm(false);
      setIsDepartForm(false);
      getMetas();
    } else {
      toast.error(json?.error);
    }
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => currentModalData?.actionType == 'Status' ? onStatus() : onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            actionType={currentModalData?.actionType}
            data={currentModalData}
          />
          {/* Add or Update depart form */}
          <Modal isOpen={isDepartForm} toggle={() => setIsDepartForm(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <h5 className="text-black font-size-20">{currentModalData ? 'Update Industry!' : 'Add New Industry !'}</h5>
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v, 'depart')
                  }}
                >
                  <div className="mb-3">
                    <AvField
                      name="title"
                      label="Name"
                      className="form-control"
                      placeholder="Enter name"
                      type="text"
                      required
                      value={currentModalData?.title}
                    />
                  </div>
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{ backgroundColor: Utils.themeColor }}
                          onClick={() => setIsDepartForm(false)}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{ backgroundColor: Utils.themeColor }}
                        >
                          {currentModalData ? 'Update' : 'Add'}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>

          {/* Add or Update course form */}
          <Modal isOpen={isCourseForm} toggle={() => setIsCourseForm(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <h5 className="text-black font-size-20">{currentModalData ? 'Update Course!' : 'Add New Course !'}</h5>
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v, 'course')
                  }}
                >
                  <div className="mb-3">
                    <AvField
                      name="title"
                      label="Name"
                      className="form-control"
                      placeholder="Enter name"
                      type="text"
                      required
                      value={currentModalData?.title}
                    />
                  </div>
                  {/* <div className="mb-3">
                    <AvField
                      name="sector"
                      label="Industry / Sector"
                      className="form-control"
                      // placeholder="Enter Sector"
                      type="select"
                      required
                      value={currentModalData?.sector ? currentModalData?.sector[0]?._id : null}
                    >
                      <option value="">Select Industry</option>
                      {departData?.map((item)=>{
                        if(item?.isActive)
                        return(
                          <option value={item?._id}>{item?.title}</option>
                        )
                      })}
                    </AvField>
                  </div>
                  <div className="mb-3">
                    <AvField
                      name="type"
                      label="Type"
                      className="form-control"
                      placeholder="Enter Type"
                      type="text"
                      required
                      value={currentModalData?.type}
                    />
                  </div> */}
                  {/* <div className="mb-3">
                    <AvField
                      name="duration"
                      label="Duration"
                      className="form-control"
                      placeholder="Enter Duration"
                      type="text"
                      required
                      value={currentModalData?.duration}
                    />
                  </div> */}
                  <div className="form-group mb-3">
                    <AvRadioGroup name="isNAPS" required value={currentModalData?.isNAPS ? "yes" : 'no'}>
                      <Label >Is NAPS</Label>
                      {/* <div className="d-flex"> */}
                      <AvRadio label="Yes" value={"yes"} />
                      <AvRadio label="No" value={"no"} />
                      {/* </div> */}
                    </AvRadioGroup>
                  </div>
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{ backgroundColor: Utils.themeColor }}
                          onClick={() => setIsCourseForm(false)}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{ backgroundColor: Utils.themeColor }}
                        >
                          {currentModalData ? 'Update' : 'Add'}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>

          {/* Add or Update Qualification form */}
          <Modal isOpen={isQualiForm} toggle={() => setIsQualiForm(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <h5 className="text-black font-size-20">{currentModalData ? 'Update Qualification!' : 'Add New Qualification!'}</h5>
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v, 'quali')
                  }}
                >
                  <div className="mb-3">
                    {/* <div className="mb-3">
                      <AvField
                        name="type"
                        label="Type"
                        className="form-control"
                        placeholder="Enter Type"
                        type="text"
                        required
                        value={currentModalData?.type}
                      />
                    </div> */}
                    <AvField
                      name="title"
                      label="Name"
                      className="form-control"
                      placeholder="Enter name"
                      type="text"
                      required
                      value={currentModalData?.title}
                    />
                  </div>
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{ backgroundColor: Utils.themeColor }}
                          onClick={() => setIsQualiForm(false)}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{ backgroundColor: Utils.themeColor }}
                        >
                          {currentModalData ? 'Update' : 'Add'}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>

          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                  <div>
                    <CardTitle className="h4">{props.role}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {role} you have added before, All the <code>Opportunities</code> will be added according to {role}.
                    </CardSubtitle>
                  </div>
                </div>

                {path == 'department' &&
                  <>
                    <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                      <h5>Industry</h5>
                      <div className="text-center" style={{ marginLeft: 'auto' }}>
                        <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => setIsDepartForm(true)}>
                          Add
                        </Button>
                      </div>
                    </div>

                    <DataTable
                      columns={departColumns}
                      data={departData}
                      pagination
                      customStyles={{
                        headCells: {
                          style: {
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: 15,
                            maxWidth: 80
                          },
                        },
                        cells: {
                          style: {
                            maxWidth: 50
                          }
                        }
                      }}
                    />
                  </>
                }
                {path == 'course' &&
                  <>
                    <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                      <h5>Courses</h5>
                      <div className="text-center" style={{ marginLeft: 'auto' }}>
                        <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => setIsCourseForm(true)}>
                          Add
                        </Button>
                      </div>
                    </div>

                    <DataTable
                      columns={columns}
                      data={data}
                      pagination
                      customStyles={{
                        headCells: {
                          style: {
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: 15,
                            maxWidth: 80
                          },
                        },
                        cells: {
                          style: {
                            maxWidth: 50
                          }
                        }
                      }}
                    />
                  </>
                }
                {path == 'qualification' &&
                  <>
                    <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                      <h5>Qualifications</h5>
                      <div className="text-center" style={{ marginLeft: 'auto' }}>
                        <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => setIsQualiForm(true)}>
                          Add
                        </Button>
                      </div>
                    </div>

                    <DataTable
                      columns={qualiColumns}
                      data={qualiData}
                      pagination
                      customStyles={{
                        headCells: {
                          style: {
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: 15,
                            maxWidth: 80
                          },
                        },
                        cells: {
                          style: {
                            maxWidth: 50
                          }
                        }
                      }}
                    />

                  </>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    </React.Fragment >
  )
}

export default Table;
